import { AxiosRequestConfig } from 'axios';
import moment from 'moment';
import { currentLanguage } from 'shared/constants/common';
import { findCookieValue } from 'shared/util/utility';

const BestSellerApiWrapper = (requests: any) => {
	// const Cookies:any = document.cookie;
	return {
		getAllBestSellersGame: () => {
			const config: AxiosRequestConfig = {
				headers: {
					'Request-Language': currentLanguage,
					'x-odds-session': findCookieValue('x-odds-session'),
				},
			};
			return requests.get('/market/events/bestsellers', config);
		},
		getTodaysOfferGame: () => {
			const config: AxiosRequestConfig = {
				headers: {
					'Request-Language': currentLanguage,
					'x-odds-session': findCookieValue('x-odds-session'),
				},
			};
			return requests.get(`/market/events/today-offers/${moment().format('YYYY-MM-DD')}`, config);
		},
		prematchEventDetail: (id: number, sportId: number) => {
			const config: AxiosRequestConfig = {
				headers: {
					'Request-Language': currentLanguage,
					'x-odds-session': findCookieValue('x-odds-session'),
				},
				params: { sportId },
			};
			return requests.get(`market/events/${id}`, config);
		},
		eventDetailsById: (id: number) => {
			const config: AxiosRequestConfig = {
				headers: {
					'Request-Language': currentLanguage,
					'x-odds-session': findCookieValue('x-odds-session'),
				},
			};
			return requests.get(`/market/categories/${id}/events/dropdown`, config);
		},
	};
};

export default BestSellerApiWrapper;
